import script from "./VerificationInfoJp.vue?vue&type=script&setup=true&lang=ts"
export * from "./VerificationInfoJp.vue?vue&type=script&setup=true&lang=ts"

import "./VerificationInfoJp.vue?vue&type=style&index=0&id=5818d6c0&scoped=true&lang=css"

import exportComponent from "/home/forge/client.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5818d6c0"]])

export default __exports__